import ApiService from "@/core/services/api.service";
import { STATUS_CODE } from "@/core/config/constant";
import { SET_ERROR } from "@/core/services/store/auth.module";
// mutation types
const GET_LIST_ANSWER_FORM_CHILD = 'getListAnswerFormChild'
const SET_LIST_ANSWER_FORM_CHILD = 'SetListAnswerFormChild'
const { SUCCESS, BAD_REQUEST } = STATUS_CODE;
const SET_STATUS = "SetStatus"
const SET_ERROR_MESSAGE = "SetErrorMessage"
const SET_APPROVAL = "setApproval"
const GET_LIST_ANSWER_FORM4 = "getListAnswerForm4"
const GET_LIST_ANSWER_FORM5 = "getListAnswerForm5"
const GET_LIST_EXIST_FORM4 = "getListExistForm4"
const SET_LIST_EXIST_FORM4 = "setListExistForm4"
const GET_LIST_EXIST_FORM5 = "getListExistForm5"
const SET_LIST_EXIST_FORM5 = "setListExistForm5"


const state = {
  listAnswer: null,
  status: null,
  errors: null,
  list_exist_form4: [],
  list_exist_form5: []
};

const getters = {
  form2: state => state.listAnswer ? state.listAnswer.form2 : {},
  form3: state => state.listAnswer ? state.listAnswer.form3 : {},
  listItemNameForm2: state => state.listAnswer ? state.listAnswer.item_name_form2 : null,
  listItemNameForm3: state => state.listAnswer ? state.listAnswer.item_name_form3 : null,
  answerChildErrors: state => state.errors,
  answerChildStatus: state => state.status,
  form2Price: state => state.listAnswer ? state.listAnswer.form_answer.form2_price : 0,
  form3Price: state => state.listAnswer ? state.listAnswer.form_answer.form3_price : 0,
  averagePrice: state => state.listAnswer ? state.listAnswer.form_answer.verage_price : '--',
  form4: state => Object.keys(state.listAnswer).length ? state.listAnswer.form_item : [],
  form5: state => Object.keys(state.listAnswer).length ? state.listAnswer.form_item : [],
  form4AnswerId: state => Object.keys(state.listAnswer).length ? state.listAnswer.form_answer.answer_id : null,
  form4Link: state => state.listAnswer?.form_answer ? state.listAnswer.form_answer.form_answer_value : null,
  form5AnswerId: state => Object.keys(state.listAnswer).length ? state.listAnswer.form_answer.answer_id : null,
  form5Link: state => state.listAnswer?.form_answer ? state.listAnswer.form_answer.form_answer_value : null,
  listExistForm4: state => state.list_exist_form4,
  listExistForm5: state => state.list_exist_form5,
  formAnserDetail :  state => (state.listAnswer &&  state.listAnswer.form_answer) ? state.listAnswer.form_answer : {}

};


const mutations = {
  [SET_LIST_ANSWER_FORM_CHILD](state, listAnswer) {
    state.listAnswer = listAnswer;
  },
  [SET_STATUS](state, code) {
    state.status = code;
  },
  [SET_ERROR_MESSAGE](state, errors) {
    state.errors = errors
  },
  [SET_LIST_EXIST_FORM5](state, list) {
    state.list_exist_form5 = list
  },
  [SET_LIST_EXIST_FORM4](state, list) {
    state.list_exist_form4 = list
  }

};


const actions = {
  async [GET_LIST_ANSWER_FORM_CHILD](context, payload) {
    context.commit(SET_STATUS, null)
    context.commit(SET_ERROR_MESSAGE, null)
    context.commit(SET_LIST_ANSWER_FORM_CHILD, null);

    try {
      const answer_id = payload.answer_id
      const time = payload.time
      const response = await ApiService.get(`form/list-answer-form-chlid/${answer_id}?date_form=${time.date_form}&date_to=${time.date_to}&tax_flag=${time.tax_flag}`)
      if (response.data.code == SUCCESS) {
        context.commit(SET_LIST_ANSWER_FORM_CHILD, response.data.data);
        context.commit(SET_STATUS, response.data.code)
      }
      if (response.data.code == BAD_REQUEST) {
        context.commit(SET_STATUS, response.data.code)
        context.commit(SET_ERROR_MESSAGE, response.data.data)
      }
    } catch (e) {
      if (e.response.data.code == ERROR_SERVER) {
        context.commit(SET_ERROR, e.response.data.message);
        throw e.response.data.message
      } else {
        throw e;
      }
    }

  },
  async [GET_LIST_ANSWER_FORM4](context, payload) {
    context.commit(SET_STATUS, null)
    context.commit(SET_ERROR_MESSAGE, null)
    context.commit(SET_LIST_ANSWER_FORM_CHILD, null);

    try {
      const answer_id = payload.answer_id
      const year = payload.year
      const response = await ApiService.get(`form/list-answer-form-4/${answer_id}?year=${year}`)
      if (response.data.code == SUCCESS) {
        context.commit(SET_LIST_ANSWER_FORM_CHILD, response.data.data);
        context.commit(SET_STATUS, response.data.code)
      }
      if (response.data.code == BAD_REQUEST) {
        context.commit(SET_STATUS, response.data.code)
        context.commit(SET_ERROR_MESSAGE, response.data.data)
      }
    } catch (e) {
      if (e.response.data.code == ERROR_SERVER) {
        context.commit(SET_ERROR, e.response.data.message);
        throw e.response.data.message
      } else {
        throw e;
      }
    }
  },
  async [GET_LIST_ANSWER_FORM5](context, payload) {
    context.commit(SET_STATUS, null)
    context.commit(SET_ERROR_MESSAGE, null)
    context.commit(SET_LIST_ANSWER_FORM_CHILD, null);

    try {
      const answer_id = payload.answer_id
      const date = payload.date
      const response = await ApiService.get(`form/list-answer-form-5/${answer_id}?date=${date}`)
      if (response.data.code == SUCCESS) {
        context.commit(SET_LIST_ANSWER_FORM_CHILD, response.data.data);
        context.commit(SET_STATUS, response.data.code)
      }
      if (response.data.code == BAD_REQUEST) {
        context.commit(SET_STATUS, response.data.code)
        context.commit(SET_ERROR_MESSAGE, response.data.data)
      }
    } catch (e) {
      if (e.response.data.code == ERROR_SERVER) {
        context.commit(SET_ERROR, e.response.data.message);
        throw e.response.data.message
      } else {
        throw e;
      }
    }
  },

  async [GET_LIST_EXIST_FORM5](context, answer_id) {
    context.commit(SET_LIST_EXIST_FORM5, []);

    try {
      const response = await ApiService.get(`form/check-exist-answer/${answer_id}?form_type=5`)
      if (response.data.code == SUCCESS) {
        context.commit(SET_LIST_EXIST_FORM5, response.data.data);
        context.commit(SET_STATUS, response.data.code)
      }
      if (response.data.code == BAD_REQUEST) {
        context.commit(SET_STATUS, response.data.code)
        context.commit(SET_ERROR_MESSAGE, response.data.data)
      }
    } catch (e) {
      if (e.response.data.code == ERROR_SERVER) {
        context.commit(SET_ERROR, e.response.data.message);
        throw e.response.data.message
      } else {
        throw e;
      }
    }
  },
  async [GET_LIST_EXIST_FORM4](context, answer_id) {
    context.commit(SET_LIST_EXIST_FORM4, []);

    try {
      const response = await ApiService.get(`form/check-exist-answer/${answer_id}?form_type=4`)
      if (response.data.code == SUCCESS) {
        context.commit(SET_LIST_EXIST_FORM4, response.data.data);
        context.commit(SET_STATUS, response.data.code)
      }
      if (response.data.code == BAD_REQUEST) {
        context.commit(SET_STATUS, response.data.code)
        context.commit(SET_ERROR_MESSAGE, response.data.data)
      }
    } catch (e) {
      if (e.response.data.code == ERROR_SERVER) {
        context.commit(SET_ERROR, e.response.data.message);
        throw e.response.data.message
      } else {
        throw e;
      }
    }
  },
  async [SET_APPROVAL](context, payload) {
    context.commit(SET_STATUS, null)
    context.commit(SET_ERROR_MESSAGE, null)
    try {
      const answer_id = payload.answer_id
      const status = payload.status
      const reject_reason = payload.reject_reason
      const response = await ApiService.post(`/form/approval-answer/${answer_id}/${status}`, { reject_reason })
      if (response.data.code == SUCCESS) {
        context.commit(SET_STATUS, response.data.code)
      }
      if (response.data.code == BAD_REQUEST) {
        context.commit(SET_STATUS, response.data.code)
        context.commit(SET_ERROR_MESSAGE, response.data.data)
      }
    } catch (e) {
      if (e.response.data.code == ERROR_SERVER) {
        context.commit(SET_ERROR, e.response.data.message);
        throw e.response.data.message
      } else {
        throw e;
      }
    }
  }
}



export default {
  state,
  actions,
  mutations,
  getters
};
